import NavControlsComponent from './nav-controls.component'

export default NavControlsComponent
